import React from "react";

export default function Error() {
  return <h1>Oops! Page not found !</h1>;
}
